import React from "react";
import { useTranslation } from 'react-i18next';
import BarChartPolicies from "../../../graphs/BarChartPolicies";
import StackedBarChartPolicies from "../../../graphs/StackedBarChartPolicies";
import Row from 'react-bootstrap/Row';

  

  const PoliciesResponsesMainSection = (props) => {
const { t } = useTranslation();
    
    return (
      <>
           <Row> <p className="pdf-title" style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem", marginBottom: "0.3rem"}}>
                <span className="table-grey-column-bold-text">{t(props.indicatorTitle)} </span>
                <span className="table-grey-column-non-bold-text">{t(props.indicatorText)}</span></p></Row>
     
     {props.type === "global" ?
     <Row>
    <BarChartPolicies 
    isSubquestion={false}
    data={props.dataGlobal} 
    graphTitle={props.graphTitle} 
    titleY={props.titleY} 
    titleX={props.titleX}
    /> </Row>: 
   <Row>
    <StackedBarChartPolicies 
      size={props.size}
    isSubquestion={false}
    data={props.dataRegional}
    graphTitle={props.graphTitle} 
    titleY={props.titleY} 
    /></Row>}
    </> 
    );
  };
  
  export default PoliciesResponsesMainSection;
  
